import { render, staticRenderFns } from "./WheelBattleTeamRow.vue?vue&type=template&id=46c44696&scoped=true&"
import script from "./WheelBattleTeamRow.vue?vue&type=script&lang=js&"
export * from "./WheelBattleTeamRow.vue?vue&type=script&lang=js&"
import style0 from "./WheelBattleTeamRow.vue?vue&type=style&index=0&id=46c44696&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c44696",
  null
  
)

export default component.exports